(function(factory) {
	if (typeof define === 'function' && define.amd && define.amd.jQuery) {
		define(['jquery'], factory);
	}
	else if (typeof module !== 'undefined' && module.exports) {
		factory(require('jquery'));
	}
	else {
		factory(jQuery);
	}
}(function($) {
	'use strict';

	var frcVideo = function(options) {

		var V = this;

		var defaults = {
			autoplay: 0, // Do not autoplay
			annotations: 3, // Do not show annotations
			autocreate: true, // Add player to container right away
			modestbranding: 1, // Do not display YouTube logo
			related: 0, // Do not show related videos after video ends,
			quality: 'HD720',
			template: $('<div class="video-player"><div class="video-poster"><div class="play-button"></div></div><div class="video-player-frame"></div></div>')
		};

		if (!(this instanceof frcVideo)) {
			return new frcVideo(options);
		}

		options = options || {};
		for (var def in defaults) {
			if (typeof options[def] === 'undefined') {
				options[def] = defaults[def];
			}
			else if (typeof options[def] === 'object') {
				for (var deepDef in defaults[def]) {
					if (typeof options[def][deepDef] === 'undefined') {
						options[def][deepDef] = defaults[def][deepDef];
					}
				}
			}
		}

		V.options = options;

		V.guid = function() {
			function s4() {
				return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
			};

			return 'v-'+ s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
		};

		V.pollState = function() {
			window.clearInterval(V.poll);
			V.poll = window.setInterval(function() {
				var tempState = V.Player.getPlayerState();

				if (V.state != tempState) {
					V.state = tempState;

					switch(V.state) {
						case 0: // ended
							$(V.selectors.container).attr('data-video-state', 'ended').trigger('video-ended');
						break;

						case 1: // playing
							$(V.selectors.container).attr('data-video-state', 'playing').trigger('video-playing');
						break;

						case 2: // paused
							$(V.selectors.container).attr('data-video-state', 'paused').trigger('video-paused');
						break;

						case 3: // buffering
							$(V.selectors.container).attr('data-video-state', 'buffering').trigger('video-buffering');
						break;
					}
				}

			}, 10);
		};

		V.createPlayer = function() {
			$(V.selectors.player).on('onReady', function() {
				$(V.selectors.container).addClass('ready');
			});

			V.Player = new YT.Player(V.playerId, {
				videoId: V.videoId,
				enablejsapi: 1,
				playerVars: {
					autoplay: V.options.autoplay,
					modestbranding: V.options.modestbranding,
					iv_load_policy: V.options.annotations,
					rel: V.options.related,
					vq: V.options.quality
				},
				events: {
					'onReady': function() {
						$(V.selectors.container).addClass('ready').attr('data-video-state', 'stopped').trigger('video-player-ready');
						V.pollState();
						$(V.selectors.container).data({
							frcVideo: V.Player
						});
					}
				}
			});

			$(V.selectors.poster).on('click', function() {
				V.Player.playVideo();
			});
		};

		V.removePlayer = function() {
			if ($(V.selectors.container +' iframe'+ V.selectors.player).length) {
				$(V.selectors.player).remove();
				window.clearInterval(V.poll);
			}
		};

		V.init = function() {
			if (!V.options.source.hasClass('video-original')) {
				var vid = V.options.source.attr('src').match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/);

				if (vid && vid != null) {

					V.playerId = V.guid();
					V.videoId = vid[1];
					V.thumbnail = 'https://img.youtube.com/vi/'+ V.videoId +'/maxresdefault.jpg';
					V.options.source.addClass('video-original');
					V.options.template.insertBefore(V.options.source);
					V.options.source.prev().attr('data-video', V.videoId).attr('data-video-player-id', V.playerId).find('.video-player-frame').attr('id', V.playerId);
					V.selectors = {
						player: '#'+ V.playerId,
						container: '.video-player[data-video-player-id="'+ V.playerId +'"]',
						poster: '.video-player[data-video-player-id="'+ V.playerId +'"] .video-poster'
					};
					$(V.selectors.poster).css({'background-image': 'url('+ V.thumbnail +')'});

					V.alive = true;

					if (V.options.autocreate) {
						V.createPlayer();
					}
				}
			}
		};

		V.init();
	};

	window.frcVideo = frcVideo;

}));

function onYouTubePlayerAPIReady() {
	$(window).trigger('ytAPI');
}

$(function() {
	$('<script></script>').attr('src', '//www.youtube.com/iframe_api').insertBefore($('script').first());
});